// extracted by mini-css-extract-plugin
export default {"styles":"styles____mUNb","img":"img___hItpH","tip":"tip___a67oK"};